import script from "./WishlistThumbView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WishlistThumbView.vue?vue&type=script&lang=ts&setup=true"

import "./WishlistThumbView.vue?vue&type=style&index=0&id=d333c060&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d333c060"]])

export default __exports__